"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateDialog = void 0;
const react_1 = __importStar(require("react"));
const form_1 = require("../../form/form");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const react_intl_1 = require("react-intl");
const dialog_1 = require("../../../components/dialog/dialog");
const form_text_field_1 = require("../../form/fields/form-text-field");
const form_checkbox_1 = require("../../form/fields/form-checkbox");
exports.CreateDialog = react_1.forwardRef(function CreateDialog({ onConfirm }, dialogRef) {
    const ref = react_1.useRef(null);
    const handleSubmit = event_callback_hook_1.useEventCallback((values) => {
        onConfirm(values);
    });
    const handleSave = event_callback_hook_1.useEventCallback(() => {
        var _a;
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.submitForm();
    });
    return (react_1.default.createElement(dialog_1.Dialog, { ref: dialogRef, title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_NAMED_SETTINGS_DIALOG_TITLE_DETAIL", defaultMessage: "Ulo\u017Een\u00ED nastaven\u00ED" }), confirmLabel: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_NAMED_SETTINGS_BTN_SAVE", defaultMessage: "Ulo\u017Eit" }), onConfirm: handleSave }, () => (react_1.default.createElement(form_1.Form, { editing: true, initialValues: {
            id: '',
            name: '',
            settings: '',
            tag: '',
            shared: false,
        }, onSubmit: handleSubmit, ref: ref },
        react_1.default.createElement(form_text_field_1.FormTextField, { name: "name", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_NAMED_SETTINGS_LABEL_FIELD_NAME", defaultMessage: "N\u00E1zev" }) }),
        react_1.default.createElement(form_checkbox_1.FormCheckbox, { name: "shared", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_NAMED_SETTINGS_LABEL_FIELD_SHARED", defaultMessage: "Sd\u00EDlen\u00E9" }) })))));
});
//# sourceMappingURL=create-dialog.js.map